import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from 'components/ErrorMessage';
import Raven from 'libs/Raven';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true
    });
    Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ marginTop: '20px' }}>
          <ErrorMessage />
        </div>
      );
    }
    const { children } = this.props;
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.jsx